import React from 'react';
import { MindMapContext } from '../../../../Context/contex';
import DocumentTitle from '../../../DocumentTitle/DocumentTitle';
import PrivacyIcon from '../../../PrivacyIcon/PrivacyIcon';
import CompleteDocument from '../../../CompleteDoc/completeDoc';
import SavingStatus from '../../../SavingStatus/SavingStatus';
import styles from './TitleBlock.module.css';

/** The title row (name, privacy, complete) over the save status line. */
const TitleBlock = () => {
    const { isReadOnly, isTemplateDocument } = MindMapContext();

    return (
        <div className={styles.titleBlock}>
            <div className={styles.titleRow}>
                <DocumentTitle />
                {!isTemplateDocument && <PrivacyIcon />}
                {!isReadOnly && !isTemplateDocument && <CompleteDocument />}
            </div>
            <SavingStatus />
        </div>
    );
};

export default TitleBlock;
